<template>
  <div class="hello"></div>
</template>

<script>
export default {};
</script>
